module.exports = __webpack_public_path__ + "img/Chemformation_logo_Primary_W.30342e71.svg";